export default class extends Controller {
  static targets = ['form', 'popup', 'nameInput', 'ownerInput'];

  connect() {
    App.Helpers.listenToCustomEvent(document, 'update-success',
      (e => e.detail.id === this.element.id && this.reloadGoal()).bind(this));
  }

  reloadGoal() {
    App.Helpers.ajaxRequest({
      url:            this.data.get('url'),
      method:         'GET',
      successHandler: res => App.Helpers.replaceElement(this.element, res)
    });
  }

  openForm(event) {
    event && event.preventDefault();
    App.Helpers.ajaxRequest({
      url:            event.target.href,
      method:         'GET',
      successHandler: this.openPopup.bind(this)
    });
  }

  closeForm(event) {
    event && event.preventDefault();
    this.popupTarget.remove();
  }

  submitForm(event) {
    event.preventDefault();
    const errorHandler = ({ responseText }) => {
      this.closeForm();
      this.openPopup(responseText);
    };
    App.Helpers.ajaxRequest({
      url:    this.formTarget.action,
      data:   App.Helpers.formDataAsString(this.formTarget),
      method: this.formTarget.method.toUpperCase(),
      successHandler: this.reloadGoal.bind(this),
      errorHandler:   errorHandler.bind(this)
    });
  }

  deleteGoal(event) {
    event.preventDefault();
    if (confirm('Are you sure?')) {
      App.Helpers.ajaxRequest({
        url:            event.target.href,
        method:         'DELETE',
        data:           { _method: 'delete' },
        successHandler: this.removeGoal.bind(this)
      });
    }
  }

  removeGoal() {
    this.element.remove();
  }

  //
  // INTERNAL USE
  //

  openPopup(res) {
    App.Helpers.appendContent(this.element, `<div class="goal--edit-form" data-${this.identifier}-target="popup">${res}</div>`);
    App.Helpers.addHandlers(this.formTarget);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/goal-controller.js